import SessionStore from "../../../../services/session/SessionStore";
import MetricsProvider, { addScript, mapUserInfo } from "./MetricsProvider";
import {difference, pickBy, debounce} from 'lodash'
import * as UrlFragmentSearch from "../../../../util/UrlFragmentSearch";


export default class Kissmetrics extends MetricsProvider {
  appId;

  constructor(appId) {
    super();
    this.appId = appId;
  }

  identify(userIdentity, userProps) {
    window._kmq.push(['identify', userIdentity]);
    window._kmq.push(['set', userProps]);
  }

  install = () => {
    window._kmq = [];
    addScript('//i.kissmetrics.com/i.js');
    addScript('//scripts.kissmetrics.com/' + this.appId + '.2.js');

    // do specific tracking just for kissmetrics
    const changeListener = debounce(() => pushNavigation(this), 2000)
    window.addEventListener('hashchange', changeListener);
  }
  recordEvent(name, properties) {
    const data = [
      'record',
      name,
      {
        ...properties,
        // kissmetrics has a hard time querying events for a user,
        // apply the user info to each and every single event
        ...(SessionStore.user ? mapUserInfo(SessionStore.user) : {})
      }
    ];
    window._kmq.push(data);
  }
}

let prev = null;
function pushNavigation(km) {
  const pathname = UrlFragmentSearch.getPathAndQuery().pathname
  const prevQueryObject = prev ? prev[2] : {}
  const queryObject = UrlFragmentSearch.getQueryObject()

  const parts = pathname.split('/').slice(1)
  const feature = '/' + parts[0]
  const rest = pathname.slice(feature.length, pathname.length)

  const getModifiedParameters = () => {
    const currentDiffPrev = pickBy(queryObject,(v,k) => prevQueryObject[k] !== v)
    const prevDiffCurrent = pickBy(prevQueryObject,(v,k) => queryObject[k] !== v)
    const combined = {...currentDiffPrev,...prevDiffCurrent}
    const keys = Object.keys(combined)
    return keys.length ? keys.join(',') : null
  }

  const getModifiedPath = () => {
    const diff = difference(parts,(prev ? prev[0]+prev[1] : "").split('/'))
    return diff.length ? diff.join('/') : null
  }

  const recordChange = !prev || prev[0] !== feature || prev[1] !== rest
  const urlChange = !!getModifiedPath() || !!getModifiedParameters()

  if (recordChange) {
    km.recordEvent(feature, {
      subsection: rest,
      ...mapUserInfo(SessionStore.user || {})
    })
  }

  if (urlChange) {
    km.recordEvent(`${feature}interaction`, {
      modifiedParameters: getModifiedParameters(queryObject,prevQueryObject),
      modifiedPath: getModifiedPath(),
      ...mapUserInfo(SessionStore.user || {})
    })
  }

  if (recordChange || urlChange) {
    prev = [feature, rest, queryObject]
  }

}
